import { Box, BoxProps, Flex, Heading } from '@chakra-ui/layout';
import { Collapse, Icon as ChakraIcon, useDisclosure } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import React from 'react';
import { ChevronDown, ChevronUp, Icon } from 'react-feather';

const MotionBox = motion(Box);
interface CardProps {
  title: string;
  icon?: Icon;
  animationDelay?: number;
  animate?: boolean;
  containerProps?: BoxProps;
  headerComponent?: JSX.Element;
  collapsable?: boolean;
  isDefaultCollapsed?: boolean;
}

export const Card: React.FC<CardProps> = ({
  containerProps,
  collapsable,
  children,
  isDefaultCollapsed,
  title,
  icon,
  animationDelay,
  animate,
  headerComponent,
}) => {
  const { isOpen, onToggle } = useDisclosure({
    defaultIsOpen: !isDefaultCollapsed,
  });
  const containerVariants = {
    hidden: {
      y: -10,
      opacity: 0,
    },
    visible: {
      y: 0,
      opacity: 1,
      transition: { delay: animationDelay },
    },
    exit: {
      y: 10,
      opacity: 0,
      transition: { duration: 0.1 },
    },
  };
  return (
    <MotionBox
      variants={containerVariants}
      initial={animate ? 'hidden' : 'visible'}
      animate={animate ? 'visible' : 'visible'}
      exit={animate ? 'exit' : 'visible'}
      overflow="hidden"
      w="full"
      bg="white"
      borderRadius="xl"
      boxShadow="md"
      {...containerProps}
    >
      <Flex
        align="center"
        bg="brand.500"
        p={4}
        onClick={(collapsable && onToggle) || undefined}
        cursor={collapsable ? 'pointer' : 'auto'}
      >
        {icon && <ChakraIcon as={icon} color="white" mr={2} />}
        {collapsable && (
          <ChakraIcon
            as={isOpen ? ChevronUp : ChevronDown}
            color="white"
            mr={2}
            boxSize="1.3em"
          />
        )}
        <Heading color="white" w="full" size="md">
          {title}
        </Heading>
        {headerComponent && <Flex alignSelf="flex-end">{headerComponent}</Flex>}
      </Flex>
      <Collapse in={isOpen}>
        <Box p={4} w="full">
          {children}
        </Box>
      </Collapse>
    </MotionBox>
  );
};
